import React from 'react'
import { Link } from 'react-router-dom'

class ButtonBackComponent extends React.Component {
  render () {
    return (
      <div style={styles.buttonContent}>
        <Link style={styles.link} to='tickets'>
          <button
            style={styles.button}>
            <span style={styles.label}>{this.props.label}</span>
          </button>
        </Link>
      </div>
    )
  }
}

const styles = {
  link: {
    textDecoration: 'none'
  },
  buttonContent: {
    marginTop: '8px',
    float: 'left',
    height: '34px'
  },
  button: {
    cursor: 'pointer',
    marginTop: '4px',
    width: '119px',
    height: '32px',
    marginLeft: '6px',
    border: '1px solid #4A4A4A',
    borderRadius: '19px',
    backgroundColor: '#16191C'
  },
  label: {
    textAlign: 'center',
    color: '#FFFFFF',
    fontSize: '13px',
    fontWeight: 500
  }
}

export default ButtonBackComponent
